import { Platform } from '@angular/cdk/platform';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserDetectionService {
  readonly platform = inject(Platform);

  public isUnsupportedBrowser(): boolean {
    return !this.platform.BLINK;
  }
}
